import { render, staticRenderFns } from "./PaymentVoucherInvoice.vue?vue&type=template&id=295b8349&scoped=true&"
import script from "./PaymentVoucherInvoice.vue?vue&type=script&lang=js&"
export * from "./PaymentVoucherInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b8349",
  null
  
)

export default component.exports